import { render, staticRenderFns } from "./CreateScoreType.vue?vue&type=template&id=25b5b804&"
import script from "./CreateScoreType.vue?vue&type=script&lang=ts&"
export * from "./CreateScoreType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports